module.exports = __webpack_public_path__ + "static/media/ic-digital-awareness.4489fa92.svg";